<div class="center-div">

  <div *ngIf="submitError" class="submit-error-toast" role="alert">
    {{ submitError }}
  </div>

  <div *ngIf="linkExpired" class="expired-container">
    <div class="expired-card" role="alert">
      <div class="expired-icon" aria-hidden="true">!</div>
      <h2 class="expired-title">This link is now expired</h2>
      <p class="expired-description">
        For any questions, please contact your clinic.
      </p>
    </div>
  </div>

  <ng-container *ngIf="!linkExpired">
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="formio-tab" data-bs-toggle="tab" data-bs-target="#formio-pane" type="button"
          role="tab">
          Intake
        </button>
      </li>
    </ul>
    <!-- Autosave problems only, never a confirmation, so nobody skips Save -->
    <div *ngIf="autosaveState.status === 'error' || autosaveState.status === 'expired'"
      class="autosave-indicator autosave-indicator--problem">
      {{ autosaveState.message }}
    </div>

    <div id="formio">

    </div>
  </ng-container>
</div>
